// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3e4_f","ranges":"BmiRanges_ranges__PprnU"};